import React from 'react';
import { Link } from 'react-router-dom';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const getKey = _ref => {
  let {
    linkTo,
    title
  } = _ref;
  const keyElem = ['breadcrumb', title];

  if (typeof linkTo === 'string') {
    keyElem.push(linkTo);
  } else if (linkTo !== undefined) {
    keyElem.push(linkTo.pathname);

    if (linkTo.search) {
      keyElem.push(linkTo.search);
    }
  }

  return keyElem.join('-');
};

const Breadcrumb = _ref2 => {
  let {
    title,
    linkTo,
    position
  } = _ref2;
  return linkTo ? /*#__PURE__*/_jsx("li", {
    itemProp: "itemListElement",
    itemScope: true,
    itemType: "https://schema.org/ListItem",
    "data-id": "breadcrumbs_index_Breadcrumb_li",
    children: /*#__PURE__*/_jsxs(Link, {
      className: style.breadcrumb,
      to: linkTo,
      itemProp: "item",
      "data-id": "breadcrumbs_index_Breadcrumb_li_Link",
      children: [/*#__PURE__*/_jsx("span", {
        itemProp: "name",
        "data-id": "breadcrumbs_index_Breadcrumb_Link_span",
        children: title
      }), /*#__PURE__*/_jsx("meta", {
        itemProp: "position",
        content: String(position),
        "data-id": "breadcrumbs_index_Breadcrumb_Link_meta"
      })]
    })
  }) : /*#__PURE__*/_jsx("li", {
    "data-id": "breadcrumbs_index_Breadcrumb_li",
    children: /*#__PURE__*/_jsx("span", {
      className: style.breadcrumb,
      "data-id": "breadcrumbs_index_Breadcrumb_li_span",
      children: title
    })
  });
};

const Breadcrumbs = _ref3 => {
  let {
    breadcrumbs
  } = _ref3;
  return /*#__PURE__*/_jsx("nav", {
    "aria-label": "Breadcrumbs",
    className: style.breadcrumbs,
    "data-id": "breadcrumbs_index_Breadcrumb_nav",
    children: /*#__PURE__*/_jsx("ol", {
      itemScope: true,
      itemType: "https://schema.org/BreadcrumbList",
      "data-id": "breadcrumbs_index_Breadcrumb_nav_ol",
      children: breadcrumbs.map((item, index) => {
        return /*#__PURE__*/_jsx(Breadcrumb, {
          title: item.title,
          linkTo: item.linkTo,
          position: index + 1,
          "data-id": "breadcrumbs_index_Breadcrumb"
        }, getKey(item));
      })
    })
  });
};

export default Breadcrumbs;